/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Chart from "../ApexChartSafe";
import { Card, Tooltip, OverlayTrigger } from "react-bootstrap";
import { Clock } from "react-bootstrap-icons";
import moment from "moment";
import momenttz from "moment-timezone";

export default function AlldylosChart({ alldylos, options, settings }) {
  const small = [];

  const large = [];
  if (alldylos.data !== undefined) {
    alldylos.data.forEach((item) => {
      small.push({ x: parseInt(item.readingDate, 10), y: item.small });
      large.push({ x: parseInt(item.readingDate, 10), y: item.large });
    });
  }
  const [apex, setApex] = useState({
    options: {
      ...options,
      colors: ["#F6AE2D", "#FF8373"],
      xaxis: {
        ...options.xaxis,
      },
      yaxis: [
        {
          ...options.yaxis[0],
          title: {
            text: "Dust Particle Monitor",
            style: {
              fontSize: "14px",
            },
          },
        },
      ],
    },
    series: [
      {
        name: "Small",
        data: [],
      },
      {
        name: "Large",
        data: [],
      },
    ],
  });

  const [RecentValue, setRecentValue] = useState({ value: 0, time: "" });
  const [RecentValueLarge, setRecentValueLarge] = useState(0);
  let indicator;
  const duration = parseInt(
    moment
      .duration(
        moment(new Date(), "HH:mm:ss a").diff(
          moment(RecentValue.time, "HH:mm:ss a")
        )
      )
      .asMinutes() % 60,
    10
  );
  if (duration > 15) {
    indicator = (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip__dylos">
            Last updated {RecentValue.time}
          </Tooltip>
        }
      >
        <Clock className="clock__icon" />
      </OverlayTrigger>
    );
  } else if (parseInt(RecentValue, 10) > 15) {
    indicator = (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip__dylo">
            Last updated {RecentValue.time}
          </Tooltip>
        }
      >
        <status-indicator active pulse style={{ margin: "0 10px" }} />
      </OverlayTrigger>
    );
  } else {
    indicator = (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={
          <Tooltip id="button-tooltip__dylos">
            Last updated {RecentValue.time}
          </Tooltip>
        }
      >
        <status-indicator active pulse positive style={{ margin: "0 10px" }} />
      </OverlayTrigger>
    );
  }

  useEffect(() => {
    setApex({
      ...apex,
      options: {
        ...apex.options,
        xaxis: {
          ...apex.options.xaxis,
          min: options.xaxis.min,
          max: options.xaxis.max,
        },
      },
      series: [
        {
          name: ">2.5um",
          data: small,
        },
        {
          name: ">10um",
          data: large,
        },
      ],
    });

    setRecentValue(
      small[0] === undefined
        ? { value: "", time: 0 }
        : {
            value: small[small.length - 1].y,
            time: momenttz(new Date(small[small.length - 1].x * 1000))
              .tz(`${settings.station_timezone}`)
              .format("HH:mm"),
          }
    );
    setRecentValueLarge(
      large[0] === undefined ? "" : large[large.length - 1].y
    );
  }, [alldylos]);
  return (
    <div className="pt-0 px-0 full-height custom-card">
      <div className="recent-value">
        <h6 className="custom-card__title">
          <span>
            {" "}
            &gt;2.5&mu;m{" "}
            <span className="value">
              {RecentValue.value !== ""
                ? parseFloat(RecentValue.value).toFixed(1)
                : "_"}
            </span>{" "}
            &gt;10&mu;m{" "}
            <span className="value">
              {RecentValueLarge !== ""
                ? parseFloat(RecentValueLarge).toFixed(1)
                : "_"}
            </span>
          </span>
        </h6>
      </div>
      <div className="full-height">
        <Chart
          id="dylos-chart"
          options={apex.options}
          series={apex.series}
          type="line"
          width="95%"
          height="250"
        />
      </div>
      <span style={{ color: "white", fontSize: ".6rem" }}>
        Particulate density &mu;g/m<sup>3</sup>
      </span>
    </div>
  );
}

AlldylosChart.propTypes = {
  alldylos: PropTypes.shape({ data: PropTypes.shape([]) }).isRequired,
  options: PropTypes.shape({
    chart: PropTypes.shape({}),
    stroke: PropTypes.shape({}),
    length: PropTypes.shape({}),
    yaxis: PropTypes.shape({}),
  }).isRequired,
  settings: PropTypes.shape({
    station_timezone: PropTypes.string,
  }).isRequired,
};
